/**
 * Helper per ricordare da quale pagina l'utente è entrato in un annuncio,
 * così il tasto "Chiudi" di PropertyDetail può riportarlo esattamente lì.
 *
 * Uso (al click su una card immobile):
 *   import { rememberBack } from "@/utils/propertyBackTracker";
 *   rememberBack(propertyId, "Tutti gli immobili", "/dashboard/annunci");
 *
 * PropertyDetail legge sessionStorage[`pronto_back_for_${id}`] e mostra il
 * pulsante "× Chiudi" che riporta a quell'URL.
 */
export function rememberBack(propertyId, label, url) {
  if (!propertyId) return;
  try {
    sessionStorage.setItem(
      `pronto_back_for_${propertyId}`,
      JSON.stringify({ label, url }),
    );
  } catch {
    /* sessionStorage non disponibile (Safari private mode) — non bloccare */
  }
}
